var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-overlay__submenu-item"},[_c('a',{staticClass:"nav-overlay__submenu-link",attrs:{"href":_vm.item.url}},[_c('span',{staticClass:"nav-overlay__submenu-link-text"},[_vm._v("\n            "+_vm._s(_vm.item.title)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }